<template>
    <div class="flex">
        <span class="w-1/2" slot="title">
            {{ discountName }} ({{ name }})
        </span>
        <span class="w-1/2" slot="subtitle">
            &euro;{{ discount }}
        </span>
    </div>
</template>

<script>

    import cartItemAddon from './CartItemAddon.vue';

    export default {
        mounted() {
            console.log('DiscountItem mounted.');
        },
        components: {
          'cart-item-addon': cartItemAddon
        },
        data() {
          return {}
        },
        props: ['product_id', 'product_uuid', 'name', 'discount', 'discountName'],
        computed: {
            formattedTotalPrice: function() {
                return numeral(this.discount).format('€0.00');
            }
        },
        watch: {},
        methods: {
            decreaseQuantity: function() {
                this.$events.fire('decreasedCartItemQty', this.product_uuid);
            },
            increaseQuantity: function() {
                this.$events.fire('increasedCartItemQty', this.product_uuid);
            }
        }
    }
</script>
